/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    addButton: {
        label: "Ajouter"
    },
    cancelButton: {
        label: "Annuler"
    },
    closeButton: {
        label: "Fermer"
    },
    confirmButton: {
        label: "Confirmer"
    },
    deleteButton: {
        label: "Supprimer"
    },
    noButton: {
        label: "Non"
    },
    okButton: {
        label: "Ok"
    },
    saveButton: {
        label: "Sauvegarder"
    },
    toggleVisibility: {
        hide: "Cacher le contenu",
        show: "Afficher le contenu"
    },
    yesButton: {
        label: "Oui"
    }
};